import { EnrollmentProposition } from '../../lib/types/models/enrollment-proposition/enrollment-proposition'
import { DeepBoolean } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type ComparePropositionWithMainPropositionResponse = DeepBoolean<EnrollmentProposition>

export const comparePropositionWithMainProposition = (
  enrollmentId: number,
  propositionId: number
): Promise<ComparePropositionWithMainPropositionResponse> => {
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.comparePropositionWithMainProposition.url, {
        id: enrollmentId,
        propositionId: propositionId
      })
    )
    .get<ComparePropositionWithMainPropositionResponse>()
}
